import { Link } from "react-router-dom";

function ThankYou() {
  return (
    <div
      style={{
        background: "#2B2B2B",
        color: "white",
        minHeight: "100vh", // ✅ better than 100vh
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "20px",
      }}
    >
      {/* SUCCESS ICON */}
      <div
        style={{
          fontSize: "60px",
          marginBottom: "20px",
        }}
      >
        ✅
      </div>

      <h1 style={{ color: "#FFC107" }}>Thank You!</h1>

      <p style={{ marginTop: "15px", maxWidth: "400px" }}>
        Your inquiry has been submitted successfully. Our team will contact you shortly.
      </p>

      {/* ACTION BUTTONS */}
      <div
        style={{
          marginTop: "25px",
          display: "flex",
          gap: "15px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Link to="/">
          <button
            style={{
              padding: "10px 20px",
              background: "#FFC107",
              border: "none",
              cursor: "pointer",
              borderRadius: "5px",
              fontWeight: "bold",
            }}
          >
            Back to Home
          </button>
        </Link>

        <a
          href="https://wa.me/917412885533"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            style={{
              padding: "10px 20px",
              background: "#25D366",
              border: "none",
              color: "white",
              cursor: "pointer",
              borderRadius: "5px",
            }}
          >
            Chat on WhatsApp
          </button>
        </a>
      </div>
    </div>
  );
}

export default ThankYou;